import React, { useState, useEffect} from 'react'
import cn from 'classnames'
import pageBg from '../../img/final-bg.webp'
import modalBg from '../../img/final-modal-bg.svg'
import modalBg2 from '../../img/final-modal-bg-2.svg'
import modalBg3 from '../../img/fourth-modal-bg.png'
import man from '../../img/final-man.webp'
import contentImg1 from '../../img/content-img-final.png'
import {Form, Button, Input, Checkbox, Radio } from 'antd'

import {Preloader, SideParameters, SpriteSvg} from '../../components'



const StartGamePage = ({
	handleNextPage,
	isLoaded,
	setIsLoaded,
	startPage,
}) => {
	const [isVisibleContent, setIsVisibleContent] = useState(false)
	const [isFlag, setIsFlag] = useState(false)
	const [isFirstForm, setIsFirstForm] = useState(false)
	const [isSecondForm, setIsSecondForm] = useState(false)
	const [isThirdForm, setIsThirdForm] = useState(false)
	const [isFinalForm, setIsFinalForm] = useState(false)
	const [isAfterFinalForm, setAfterIsFinalForm] = useState(false)
	const [isShowCOntent, setIsShowCOntent] = useState(false)
	const [isShowMan, setIsShowMan] = useState(false)
	const [isValidateCheckBox1, setIsValidateCheckBox1] = useState(false)
	const [isValidateCheckBox2, setIsValidateCheckBox2] = useState(false)

	//  RADIO BTNS
	const [value1, setValue1] = useState('7', '53', '55', '49', '47', '54',);
	const plainOptions = [
		{ label: 'Строю/ремонтирую для себя', value: '7' },
		{ label: 'Работаю в ЖКХ', value: '53' },
		{ label: 'Заказчик крупных объектов', value: '55' },
		{ label: 'Проектировщик', value: '49' },
		{ label: 'Торговый партнёр', value: '47' },
		{ label: 'Подрядчик', value: '65' },
	];
	const onChange1 = ({ target: { value } }) => {
		console.log('radio1 checked', value);
		setValue1(value);
	};


	useEffect(()=> {
		setTimeout(()=> {
			setIsVisibleContent(true)
		},5000)
	},[])

	const [form, form2] = Form.useForm()

	const onSubmit1 = (values) => {
		let request = new XMLHttpRequest();
		let data = new FormData();
		data.append("EMAIL", values.eMail);
		window.email = values.eMail
		window.ym(1188538,'reachGoal','poluchit-kalendar')
		request.open("POST", "assets/ajax/send.php", true)
		request.responseType = "json"
		request.send(data)
		request.onload = () => {
			window.elementId = request.response.elementId
			setIsFinalForm(true)
			setIsThirdForm(false)
		};
		request.onerror = () => {
			alert('error');
		}
	}

	const onSubmit2 = (values) => {
		let request = new XMLHttpRequest();
		let data = new FormData();
		window.ym(1188538,'reachGoal','ya-gotov')
		data.append("RADIO_GROUP", values.radioGroup)
		data.append("ELEMENT_ID", window.elementId)
		data.append("EMAIL", window.email)
		request.open("POST", "assets/ajax/send.php", true)
		request.responseType = "json"
		request.send(data);
		request.onload = () => {
			setIsFinalForm(false)
			setAfterIsFinalForm(true)
		};
		request.onerror = () => {
			alert('error');
		}
	}

	const handleStart = () => {
		setIsFlag(true)
		setIsFirstForm(true)
			setTimeout(()=> {
				setIsSecondForm(true)
				setIsShowCOntent(true)
				setIsShowMan(true)
			},2000)
	}

	const handleSecondModal = () => {
		setIsSecondForm(false)
		setIsShowMan(false)
		setIsThirdForm(true)
	}
	const handleThirdModal = () => {
		setIsThirdForm(false)
		setIsFinalForm(true)
	}

	const onChangeCheckBox1 = (e) => {
		setIsValidateCheckBox1(!isValidateCheckBox1)
	};
	const onChangeCheckBox2 = (e) => {
		setIsValidateCheckBox2(!isValidateCheckBox2)
	}

	return (
		<>

			<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded}/>

			<div className={cn(
				'full-page',
				'final-page',
				isLoaded && 'active'
			)} >
				<SideParameters
					knowledge={4}
					skill={4}
					exp={4}
					dexterity={4}
					strong={4}
				/>

				<div className="page-bg">
					<img className='bg-img' src={pageBg} alt=""/>
					{isFlag &&<img className='flag' src={contentImg1} alt=""/>}
				</div>

					<div className={cn(
								 'page-content',
						isVisibleContent && 'active',
						isShowCOntent && 'activeFinal'
							 )}>

						<div className={cn(
							'modal', 'first-modal',
							isFirstForm && 'disabled'
						)}>
							<div className="modal-content">
								<div className="btn-wrap jcc">
									<div onClick={() => handleStart()} className="btn green" style={{width: '250px'}}>
										<SpriteSvg id='after-game-page-btn-green-bg'/>
										<span>Поставить флаг</span>
									</div>
								</div>
							</div>
						</div>


						<div className={cn(
							'modal', 'second-modal',
							!isSecondForm && 'disabled'
						)}>
							<div className="modal-bg">
								<img src={modalBg} alt=""/>
							</div>
							<div className="modal-content">
								<div className="text">
									<p className='mg-b-24'>Поздравляю! Рад, что не ошибся в тебе! Вижу истинный дух покорителя пика ТЕХНОНИКОЛЬ.</p>
									<p className='mg-b-24'>Не теряй настроя и завоёвывай будущие вершины с тем же успехом. Помни: твои знания, опыт и мастерство всегда будут верными попутчиками к достижению новых вершин!</p>
								</div>

								<div className="btn-wrap jcs">
									<div onClick={()=> handleSecondModal()} className="btn green" style={{width: '250px'}}>
										<SpriteSvg id='after-game-page-btn-green-bg'/>
										<span>Забрать награду</span>
									</div>
								</div>
							</div>
						</div>


						<div className={cn(
							'modal', 'third-modal',
							!isThirdForm && 'disabled'
						)}>
							<div className="modal-bg">
								<img src={modalBg2} alt=""/>
							</div>
							<div className="modal-content">
								<div className="title">
									<p>Шаг 1</p>
								</div>
								<Form
									form={form}
									name='person-search'
									layout='vertical'
									onFinish={onSubmit1}
									className='form'
								>
								<Form.Item
									name='eMail'
							    className='mg-b-8'
									rules={[{ required: true, message: 'Введите email' }]}
								>
									<Input
										type='email'
										placeholder='Введите E-mail'
									/>

								</Form.Item>

									<Form.Item
										name='eMail2'
										className='mg-b-8'>
										<Checkbox onChange={onChangeCheckBox1}>Я согласен получать рассылки ООО «ТЕХНОНИКОЛЬ — строительные системы»</Checkbox>
									</Form.Item>

									<Form.Item
										name='eMail3'
										className='mg-b-8'
									>
										<Checkbox onChange={onChangeCheckBox2}>Я согласен на обработку <a class="checkbox-link" href="https://www.tn.ru/agreement/" target="_blank">персональных данных</a> в соответствии с <a class="checkbox-link" href="https://www.tn.ru/privacy/" target="_blank">политикой ООО «ТЕХНОНИКОЛЬ — строительные системы»</a></Checkbox>
									</Form.Item>

								<div className="btn-wrap jcs">
									<Button
										size='m'
										type='ghost'
										htmlType='submit'
										className={cn(
											'btn ', 'green',
											!isValidateCheckBox1 && 'disabled',
											!isValidateCheckBox2 && 'disabled'
										)}
										style={{width: '250px'}}
									>
										<SpriteSvg id='after-game-page-btn-green-bg'/>
										<span>Получить календарь</span>
									</Button>
								</div>
								</Form>
							</div>
						</div>

							<div className={cn(
								'modal', 'third-modal',
								!isFinalForm && 'disabled'
							)}>
								<div className="modal-bg">
									<img src={modalBg2} alt=""/>
								</div>
								<div className="modal-content">
									<div className="title">
										<p>Шаг 2</p>
									</div>
									<div className="text mg-b-12">
										<p>Награда уже в почте!</p>
										<p>Но вас ждут новые победы — выберите сферу, которую хотите покорить с нашими рассылками</p>
									</div>
									<Form
										form={form2}
										name='person-search'
										layout='vertical'
										onFinish={onSubmit2}
									>
									<Form.Item
										name='radioGroup'
										className='mg-b-8'
										>
										<Radio.Group options={plainOptions} onChange={onChange1} value={value1} />
									</Form.Item>

									<Form.Item>
										<Button
											size='m'
											type='ghost'
											htmlType='submit'
											className="btn green" style={{width: '250px'}}
										>
											<SpriteSvg id='after-game-page-btn-green-bg'/>
											<span>Я готов</span>
										</Button>
									</Form.Item>
									</Form>

								</div>
							</div>



						<div className={cn(
							'modal', 'fourth-modal',
							!isAfterFinalForm && 'disabled'
						)}>
							<div className="modal-bg">
								<img src={modalBg3} alt=""/>
							</div>
							<div className="modal-content">
								<div className="title">
									<p>Спасибо!</p>
								</div>
								<div className="text">
									<p className='mg-b-24'>Проверьте ваш почтовый ящик — ваш приз ждет вас!</p>
								</div>
								<div className="btn-wrap jcs mg-b-24">
									<a target='_blank' href='https://www.tn.ru/' className="btn green mg-r-16" style={{width: '180px'}}>
										<SpriteSvg id='final-btn-green'/>
										<span>На сайт</span>
									</a>

									<div onClick={()=> handleNextPage(startPage)} className="btn border-green" style={{width: '180px'}}>
										<SpriteSvg id='after-game-page-btn-border-bg'/>
										<span>Играть заново</span>
									</div>
								</div>

								<div className="text">
									<p className='mg-b-24' style={{color: 'var(--green)'}}>Подпишитесь на наши группы в социальных сетях!</p>
								</div>

								<div className="socials grid-2">
									<div className="block">
										<div className="sub-title">
											<p>Для частных клиентов:</p>
										</div>
										<div className="social-list">
											<a target='_blank' href='https://vk.com/technonicol' className="social-item">
												<SpriteSvg id='vk'/>
											</a>
											<a target='_blank' href='https://ok.ru/technonicol' className="social-item">
												<SpriteSvg id='ok'/>
											</a>
											<a target='_blank' href='https://dzen.ru/technonicol' className="social-item">
												<SpriteSvg id='dzen'/>
											</a>
											<a target='_blank' href='https://t.me/technonicol_tg' className="social-item">
												<SpriteSvg id='telegram'/>
											</a>
											<a target='_blank' href='https://www.youtube.com/channel/UC16cIuUVnnoQ190WUUY5osQ' className="social-item">
												<SpriteSvg id='league'/>
											</a>
										</div>
									</div>

									<div className="block">
										<div className="sub-title">
											<p>Для профессиональных клиентов: </p>
										</div>
										<div className="social-list">
											<a target='_blank' href='https://vk.com/technonicol.expert' className="social-item">
												<SpriteSvg id='vk'/>
											</a>
											<a target='_blank' href='https://t.me/technonicol_expert' className="social-item">
												<SpriteSvg id='telegram'/>
											</a>
											<a target='_blank' href='https://www.youtube.com/user/TechnoNICOLive' className="social-item">
												<SpriteSvg id='youtube'/>
											</a>
										</div>
									</div>
								</div>

							</div>
						</div>


						<div className={cn(
							'content',
							'center',
							!isShowMan && 'disabled'
						)}>
							<div className="img-wrap">
								<img src={man} alt=""/>
							</div>

						</div>

					</div>

				</div>

		</>
	)

}

export default StartGamePage